
export class Events {
  private listeners: Record<string, Function[]> = {};
  on(name: string, cb: Function) {
    (this.listeners[name] ||= []).push(cb);
    return { name, cb };
  }
  offref(ref: { name?: string; cb?: Function }) {
    if (!ref?.name || !ref?.cb) return;
    this.listeners[ref.name] = (this.listeners[ref.name] || []).filter((cb) => cb !== ref.cb);
  }
  trigger(name: string, ...args: unknown[]) {
    for (const cb of this.listeners[name] || []) cb(...args);
  }
}
export class MarkdownRenderChild {
  constructor(public containerEl: HTMLElement) {}
  registerEvent(_ref: unknown) {}
  onload() {}
}
export class ItemView {
  contentEl: HTMLElement;
  constructor(_leaf?: unknown) {
    this.contentEl = document.createElement('div');
  }
  registerEvent(_ref: unknown) {}
}
export class WorkspaceLeaf {}
export class Plugin {}
export class TFile {}
export class TFolder { children: unknown[] = []; }
export class TAbstractFile {}
export class Notice {
  constructor(message: string) { console.info(message); }
}
